var exports = {
  "nM": "SecurityTab.module__row___WWR0Wm",
  "u4": "SecurityTab.module__rowContent___WWR0Wm",
  "Pf": "SecurityTab.module__label___WWR0Wm",
  "h_": "SecurityTab.module__description___WWR0Wm",
  "i4": "SecurityTab.module__warningText___WWR0Wm",
  "yF": "SecurityTab.module__divider___WWR0Wm",
  "pT": "SecurityTab.module__passkeyList___WWR0Wm",
  "EB": "SecurityTab.module__passkeyItem___WWR0Wm",
  "Nd": "SecurityTab.module__passkeyInfo___WWR0Wm",
  "gb": "SecurityTab.module__passkeyName___WWR0Wm",
  "fm": "SecurityTab.module__passkeyDetails___WWR0Wm",
  "aL": "SecurityTab.module__passkeyActions___WWR0Wm",
  "Hk": "SecurityTab.module__claimButton___WWR0Wm",
};

module.exports = exports;
